import React from "react";

// Plain wrapper: content is shown statically (no scroll-in animation).
// `delay` is accepted and ignored so existing call sites keep working.
// eslint-disable-next-line no-unused-vars
const Reveal = ({ children, delay = 0, className = "", as: Tag = "div" }) => (
  <Tag className={className}>{children}</Tag>
);

export default Reveal;
